// Textos del módulo Pedidos (orders.tsx) y del aviso de pedido web
// (aviso-pedido-web.tsx). Ver src/i18n/textos.ts.
//
// Los ESTADOS ('abierto', 'en_preparacion', …) son valores del backend y no
// están acá: orders.tsx los mapea a estas claves (est*) solo para mostrarlos.
import { defineTextos } from '../textos.ts';

export const textosPedidos = defineTextos({
  titulo: 'Pedidos',

  // --- etiquetas de estado (mapa estado → clave en orders.tsx) ---
  estAbierto: 'Abierto',
  estEnPreparacion: 'En preparación',
  estListo: 'Listo',
  estEntregado: 'Entregado',
  estPrefactura: 'Prefactura',
  estPagado: 'Pagado',
  estPagadoDian: 'Pagado · DIAN',
  estCancelado: 'Cancelado',

  // --- toasts / confirmaciones ---
  errorCargandoPedidos: 'Error cargando pedidos',
  accionFallida: 'Acción fallida',
  noSePuedeVolverMas: 'No se puede volver más atrás',
  yaEstadoInicial: 'El pedido ya está en su estado inicial.',
  volverAEstado: '¿Volver a "{estado}"?',
  seRestaurara: 'El pedido {ref} se restaurará al estado anterior.',
  volverAtras: 'Volver atrás',
  cancelar: 'Cancelar',
  pedidoYaFacturado: 'Pedido ya facturado',
  revertirFacturado: 'Para revertir un pedido facturado necesitas emitir una nota crédito DIAN. Esta funcionalidad estará disponible próximamente.',
  entendido: 'Entendido',
  cancelarPedidoRef: '¿Cancelar el pedido {ref}?',
  noSePuedeDeshacer: 'Esta acción no se puede deshacer.',
  cancelarPedido: 'Cancelar pedido',
  volver: 'Volver',

  // --- lista ---
  statTotal: 'Total',
  statAbiertos: 'Abiertos',
  statEnPreparacion: 'En preparación',
  statListos: 'Listos',
  statPorCobrar: 'Por cobrar',
  pedidoParaLlevar: 'Pedido para llevar',
  filtroTodos: 'Todos',
  filtroActivos: 'Activos',
  filtroAbiertos: 'Abiertos',
  filtroEnPreparacion: 'En preparación',
  filtroListos: 'Listos',
  filtroEntregados: 'Entregados',
  filtroPrefactura: 'Prefactura',
  filtroPagados: 'Pagados',
  filtroCancelados: 'Cancelados',
  nPedidos: '{n} pedido(s)',
  noHayPedidos: 'No hay pedidos',
  conEstado: 'con estado "{estado}"',

  // --- tarjeta ---
  mesaN: 'Mesa {nombre}',
  grupoN: 'Grupo {nombre}',
  domicilio: 'Domicilio',
  paraLlevar: 'Para llevar',
  envioSinConfirmar: 'Sin confirmar — verificar en el courier',
  buscandoMensajero: 'Buscando mensajero…',
  sinMensajero: 'Sin mensajero asignado',
  pedidoWebTitle: 'Pedido hecho en salonika.com.co — ya está pagado',
  webPagado: 'WEB · PAGADO',
  sinNombre: 'Sin nombre',
  desdeLaWeb: '· desde la web',

  // --- detalle del pedido ---
  pedidoRef: 'Pedido {ref}',
  nPers: '{n} pers.',
  total: 'Total',
  pedidoCancelado: 'Pedido cancelado',
  itemsDelPedido: 'Items del pedido',
  nLineas: '{n} líneas',
  precioCU: '{precio} c/u',
  pedidoSinItems: 'Pedido sin items',
  notas: 'Notas',
  resumen: 'Resumen',
  subtotal: 'Subtotal',
  propina: 'Propina',
  cobrarYFacturar: 'Cobrar y facturar · {total}',
  avanzarA: 'Avanzar a {estado}',
  requiereNotaCredito: 'Requiere nota crédito DIAN',
  restaurarAnterior: 'Restaurar al estado anterior',
  volverEstadoAnterior: 'Volver al estado anterior',

  // --- aviso de pedido web (aviso-pedido-web.tsx) ---
  pagoConfirmadoBold: 'Pago confirmado por Bold · Pedido web {ref}',
  yaEntroCocina: ' · ya entró a la cocina',
  sede: 'sede',
  visto: 'Visto',
}, {
  titulo: 'Orders',

  estAbierto: 'Open',
  estEnPreparacion: 'Preparing',
  estListo: 'Ready',
  estEntregado: 'Served',
  estPrefactura: 'Pre-invoice',
  estPagado: 'Paid',
  estPagadoDian: 'Paid · DIAN',
  estCancelado: 'Cancelled',

  errorCargandoPedidos: 'Error loading orders',
  accionFallida: 'Action failed',
  noSePuedeVolverMas: 'Cannot go back any further',
  yaEstadoInicial: 'The order is already in its initial state.',
  volverAEstado: 'Go back to "{estado}"?',
  seRestaurara: 'Order {ref} will be restored to the previous state.',
  volverAtras: 'Go back',
  cancelar: 'Cancel',
  pedidoYaFacturado: 'Order already invoiced',
  revertirFacturado: 'To revert an invoiced order you need to issue a DIAN credit note. This feature will be available soon.',
  entendido: 'Got it',
  cancelarPedidoRef: 'Cancel order {ref}?',
  noSePuedeDeshacer: 'This action cannot be undone.',
  cancelarPedido: 'Cancel order',
  volver: 'Back',

  statTotal: 'Total',
  statAbiertos: 'Open',
  statEnPreparacion: 'Preparing',
  statListos: 'Ready',
  statPorCobrar: 'To charge',
  pedidoParaLlevar: 'To-go order',
  filtroTodos: 'All',
  filtroActivos: 'Active',
  filtroAbiertos: 'Open',
  filtroEnPreparacion: 'Preparing',
  filtroListos: 'Ready',
  filtroEntregados: 'Served',
  filtroPrefactura: 'Pre-invoice',
  filtroPagados: 'Paid',
  filtroCancelados: 'Cancelled',
  nPedidos: '{n} order(s)',
  noHayPedidos: 'There are no orders',
  conEstado: 'with status "{estado}"',

  mesaN: 'Table {nombre}',
  grupoN: 'Group {nombre}',
  domicilio: 'Delivery',
  paraLlevar: 'To go',
  envioSinConfirmar: 'Unconfirmed: check with the courier',
  buscandoMensajero: 'Looking for a courier…',
  sinMensajero: 'No courier assigned',
  pedidoWebTitle: 'Order placed on salonika.com.co, already paid',
  webPagado: 'WEB · PAID',
  sinNombre: 'No name',
  desdeLaWeb: '· from the web',

  pedidoRef: 'Order {ref}',
  nPers: '{n} guests',
  total: 'Total',
  pedidoCancelado: 'Order cancelled',
  itemsDelPedido: 'Order items',
  nLineas: '{n} lines',
  precioCU: '{precio} each',
  pedidoSinItems: 'Order has no items',
  notas: 'Notes',
  resumen: 'Summary',
  subtotal: 'Subtotal',
  propina: 'Tip',
  cobrarYFacturar: 'Charge and invoice · {total}',
  avanzarA: 'Move to {estado}',
  requiereNotaCredito: 'Requires a DIAN credit note',
  restaurarAnterior: 'Restore to the previous state',
  volverEstadoAnterior: 'Back to the previous state',

  pagoConfirmadoBold: 'Payment confirmed by Bold · Web order {ref}',
  yaEntroCocina: ' · already sent to the kitchen',
  sede: 'branch',
  visto: 'Seen',
});
